import * as React from 'react'
import { compose, pure } from 'recompose'

import QRCode from '../../atoms/QRCode/QRCode'
import * as styles from './PrePresentationNotification.css'

interface PrePresentationNotificationProps {
  env: string
  token: string
  isHeadlessController: boolean
}

const openControllerWindow = (env: string) => {
  window.open(`controller?env=${env}`, 'controller', 'width=700,height=150')
}

const PrePresentationNotification: React.FunctionComponent<PrePresentationNotificationProps> = ({
  env,
  isHeadlessController,
  token
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.centered}>
        <div className={styles.fullscreen}>
          <h2>全画面表示に切り替える方法</h2>
          <div className={styles.os}>
            <span className={styles.name}>Macの場合</span>
            <span className={styles.key}>⌘ Cmd</span>
            <span className={styles.key}>⌃ Ctrl</span>
            <span className={styles.key}>F</span>
            <span>のあとに</span>
            <span className={styles.key}>⌘ Cmd</span>
            <span className={styles.key}>Shift</span>
            <span className={styles.key}>F</span>
          </div>
          <div className={styles.os}>
            <span className={styles.name}>Windowsの場合</span>
            <span className={styles.key}>F11</span>
            <span>のあとに</span>
            <span className={styles.key}>Ctrl</span>
            <span className={styles.key}>Shift</span>
            <span className={styles.key}>B</span>
          </div>
          <div className={styles.os}>
            <span className={styles.name}>iPadの場合</span>
            <span className={styles.sentence}>
              端末を横向きにして、iPadの「設定」で「Safari」を選択して一般の中の「タブバーを表示」をOFFにします
            </span>
          </div>
        </div>

        <div className={styles.controller}>
          {isHeadlessController ? (
            <p>画面左下の「次へ」からスライド操作できます</p>
          ) : (
            <div className={styles.button} onClick={() => openControllerWindow(env)}>
              操作パネルを表示する
            </div>
          )}
          {!isHeadlessController ? (
            <div className={styles.qr}>
              <React.Fragment>
                <p className={styles.text}>
                  モバイル端末で
                  <br />
                  操作したい方はこちら
                </p>
                <QRCode url={`${location.origin}/controller?env=${env}&token=${token}`} size={80} />
              </React.Fragment>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default compose<PrePresentationNotificationProps, PrePresentationNotificationProps>(pure)(
  PrePresentationNotification
)
